import { Avatar, Button, Fab, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import picWord from '../../Pics/picWord.png'
import picPdf from '../../Pics/picPdf.png'
import picJpg from '../../Pics/picJpg.png'


import Ws from '../../providers/Ws';
import avatar from '../../Pics/avatar.jpg'
import Utils from '../../providers/Utils';
import DrepturiAcces from '../drepturiacces/DrepturiAcces';
import LocalStorage from '../../providers/LocalStorage';
import AlertNew from '../../commons/dialogs/AlertNew';

export default class DocumenteListHr extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            alertView:false
        }
    }

    componentDidMount() {
        this.access()
    }

    u = new Utils()
    ls = new LocalStorage().GetUserData()

    access = async() =>{ 

        

        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if(this.ls.InfoUser.IsAdmin !== 1){

         
            this.setState({alertView : this.ls.InfoUser.EsteSef === 1 ? false : true})
        }

       
    }


    numeAvatar = (nume) => {

        if(nume){
            let n = nume.split(' ')

            // console.log('n :>> ', n);
    
            let firstLetters = ''
    
            if (n[0]) {
    
                firstLetters += n[0].substring(0, 1)
    
            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }
    
            firstLetters = firstLetters.toUpperCase()
    
            return firstLetters
        }else{
            return 'NA'
        }
        

    }


    goToFisaAngajat = (a) =>{ 
        console.log('a :>> ', a);
        this.props.history.push(`fisapersonalaangajat/${a.id}`)
    }


    render() {
        return (
            <div>
                <Grid container>

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll' }}>


                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>

                                    <Grid style={{ paddingTop: 5 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <select
                                                id='departament'
                                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='tva'
                                                // disabled={this.state.departamentDisabled !== 1 ? true : false}
                                                value={this.props.departament || ""}
                                                onChange={(ev) => { this.props.changeDepartament(ev) }}
                                                placeholder={this.dictionary.pontaje.departamentCautaLucrator}
                                            >

                                                <option value={-1}>{this.dictionary.pontaje.toate}</option>
                                                {this.props.departamente.map((s, idx) => {
                                                    return (
                                                        <option key={idx} value={s.id}>{s.nume}</option>
                                                    )
                                                })}
                                            </select>
                                            {/* <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.evaluari.selecteaza}</label> */}
                                        </div>

                                    </Grid>

                                    <Grid style={{ paddingTop: 5 }} item xs={8} sm={8} md={8} lg={8} xl={8}>

                                        <div style={{
                                            position: 'relative', textAlign: 'left', backgroundColor: '#f1f1f1',
                                            width: '95%'
                                        }}>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400, width: '90%' }}
                                                id='search'
                                                type="text"
                                                step='any'
                                                disabled={this.state.readOnly}
                                                className='add-project-input'
                                                placeholder='Cauta dupa nume lucrator'
                                                margin="normal"
                                                name='search'
                                                value={this.props.searchAngajat || ''}
                                                onChange={this.props.changeSearchData}

                                            />
                                            <label className='inputLabelPM' htmlFor='search'>{this.dictionary.pontaje.cauta}</label>
                                            <i style={{
                                                position: 'absolute',
                                                right: 15,
                                                top: 8,
                                                color: 'rgb(171 171 171 )',
                                                fontSize: 20
                                            }} className='material-icons'>search</i>
                                        </div>
                                    </Grid>

                                    <Grid style={{ paddingTop: 5 }} item xs={1} sm={1} md={1} lg={1} xl={1}>

                                        <Button
                                            style={{ marginRight: 20 }}

                                            className={'add-button-blue'} onClick={this.props.searchForAngajat}  >

                                            {this.dictionary.pontaje.cauta}
                                        </Button>
                                    </Grid>

                                </Grid>
                            </Grid>



                            {/* doacumente all */}
                            {this.props.angajati.length > 0 &&

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    {this.props.angajati.map((a, idx) => {

                                        return (

                                            <Grid style={{ marginBottom: 20 }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid container>

                                                    <Grid style={{ paddingTop: 5 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                        <Grid container>

                                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                {
                                                                    a.poza &&
                                                                    <div
                                                                        className='pm-angajati-picture'

                                                                        style={{ backgroundImage: `url('${a.poza ? (new Ws().adresaMedia + '/Angajati/' + a.poza) : avatar}')`, width: 36, height: 36, padding: 5 }}>

                                                                    </div>
                                                                }
                                                                {!a.poza &&

                                                                    <Avatar
                                                                        className='pm-angajati-picture'
                                                                        style={{ display: 'inline-block', textAlign: 'center', height: 24, width: 24, backgroundColor: new Utils().culoriUtilizatori(a.id), padding: 5, cursor: 'pointer' }}>
                                                                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                                        <span style={{ display: 'block' }}>{this.numeAvatar(a.nume)} </span>
                                                                    </Avatar>
                                                                    // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                                }
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                                                <span style={{ fontWeight: 500, fontSize: 14 }}>    {a.nume}</span><br />
                                                                <span style={{
                                                                    fontSize: 12,
                                                                    color: '#9a9a9a'
                                                                }}>{a.functie} - {a.nume_departament}</span>
                                                            </Grid>

                                                        </Grid>

                                                    </Grid>
                                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.fisiere}</span>
                                                        <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 600, marginTop: 5 }}>{a.documente_all}</span>

                                                    </Grid>

                                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.documenteEditabile}</span>
                                                        <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 600, marginTop: 5 }}>
                                                            <img
                                                                style={{
                                                                    width: 15,
                                                                    marginRight: 10,
                                                                    verticalAlign: 'bottom'
                                                                }}
                                                                src={picWord} />
                                                            {a.documente_word} DOC</span>


                                                    </Grid>
                                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.documentePdf}</span>
                                                        <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 600, marginTop: 5 }}>
                                                            <img
                                                                style={{
                                                                    width: 15,
                                                                    marginRight: 10,
                                                                    verticalAlign: 'bottom'
                                                                }}
                                                                src={picPdf} />
                                                            {a.documente_pdf} PDF</span>


                                                    </Grid>
                                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.documenteJpg}</span>
                                                        <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 600, marginTop: 5 }}>
                                                            <img
                                                                style={{
                                                                    width: 15,
                                                                    marginRight: 10,
                                                                    verticalAlign: 'bottom'
                                                                }}
                                                                src={picJpg} />
                                                            {a.documente_jpg} JPG</span>


                                                    </Grid>

                                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={1} sm={1} md={1} lg={1} xl={1}>

                                                        <Fab className='pm-fab-green' style={{ marginRight: 20 }} onClick={() => { this.goToFisaAngajat(a) }}>
                                                            <i className='material-icons'>visibility</i>
                                                        </Fab>


                                                    </Grid>




                                                </Grid>

                                            </Grid>
                                        )


                                    })}

                                </Grid>


                            }




                            {/* documente angajat specific */}

                            {this.props.docs.length > 0 &&
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <Grid container>
                                        <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>

                                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >

                                                <span style={{ color: 'rgb(171 171 171)' }}>{this.dictionary.pontaje.rezultateCautare}: </span>
                                                {this.props.angajat.nume}
                                            </h5>

                                        </Grid>


                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                            <div
                                                style={{
                                                    marginTop: 20,
                                                    textAlign: 'right', 
                                                    cursor:'pointer'
                                                }}
                                                onClick={this.props.getData}>
                                                <i style={{ verticalAlign: 'middle' }} className='material-icons'>keyboard_arrow_left</i>
                                                <span style={{ fontWeight: 500, fontSize: 14 }}>  {this.dictionary.pontaje.inapoi}</span>

                                            </div>
                                        </Grid>
                                    </Grid>

                                    {this.props.docs.map((a, idx) => {

                                        return (

                                            <Grid style={{ marginBottom: 20 }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid container>


                                                    <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={4} sm={4} md={4} lg={4} xl={4}>

                                                        <div style={{display: 'inline-block'}}>
                                                            <img
                                                                style={{
                                                                    width: 30,
                                                                    marginRight: 10,
                                                                    verticalAlign: 'bottom'
                                                                }}
                                                                src={
                                                                    a.type === '.jpg' ? picJpg : (a.type === '.pdf' ? picPdf : picWord)
                                                                } />
                                                        </div>

                                                        <div style={{display: 'inline-block'}}>
                                                            <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 600, marginTop: 5 }}>{a.nume}</span>
                                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{ }</span>
                                                        </div>


                                                    </Grid>

                                                    <Grid style={{ paddingTop: 5 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                        <Grid container>

                                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                {
                                                                    a.angajat.poza &&
                                                                    <div
                                                                        className='pm-angajati-picture'

                                                                        style={{ backgroundImage: `url('${a.angajat.poza ? (new Ws().adresaMedia + '/Angajati/' + a.angajat.poza) : avatar}')`, width: 36, height: 36, padding: 5 }}>

                                                                    </div>
                                                                }
                                                                {!a.angajat.poza &&

                                                                    <Avatar
                                                                        className='pm-angajati-picture'
                                                                        style={{ display: 'inline-block', textAlign: 'center', height: 24, width: 24, backgroundColor: new Utils().culoriUtilizatori(a.id), padding: 5, cursor: 'pointer' }}>
                                                                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                                        <span style={{ display: 'block' }}>{this.numeAvatar(a.angajat.nume)} </span>
                                                                    </Avatar>
                                                                    // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                                }
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                                                <span style={{ fontWeight: 500, fontSize: 14 }}>    {a.angajat.nume}</span><br />
                                                                <span style={{
                                                                    fontSize: 12,
                                                                    color: '#9a9a9a'
                                                                }}>{a.angajat.functie} - {a.angajat.nume_departament}</span>
                                                            </Grid>

                                                        </Grid>

                                                    </Grid>

                                                    <Grid style={{ textAlign: 'right', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                                        <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 600, marginTop: 10 }}>
                                                            <img
                                                                style={{
                                                                    width: 15,
                                                                    marginRight: 10,
                                                                    verticalAlign: 'bottom'
                                                                }}
                                                                src={
                                                                    a.type === '.jpg' ? picJpg : (a.type === '.pdf' ? picPdf : picWord)
                                                                } />
                                                        </span>


                                                    </Grid>
                                                    <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(205 205 205)' }}>
                                                            {this.dictionary.pontaje.creatLa}
                                                        </span>
                                                        <span style={{ marginRight: 20, fontSize: 16, display: 'block', fontWeight: 600, marginTop: 5, color: 'rgb(121	121	121	)' }}>
                                                            {this.u.ParseDataFromSql(a.cand_creat)}
                                                        </span>


                                                    </Grid>





                                                </Grid>

                                            </Grid>
                                        )


                                    })}

                                </Grid>
                            }



                        </Grid>
                    </Grid>
                </Grid>
            </div>
        );
    }
}